module.exports = __webpack_public_path__ + "img/1512025497.21500968.jpg";